exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-btn-modify {\n  align-self: center;\n}\n.btn-booking-cms-modify {\n  cursor: pointer;\n  position: relative;\n  padding-bottom: 5px;\n  display: inline-block;\n}\n.btn-booking-cms-modify a {\n  text-transform: capitalize;\n}\n.btn-booking-cms-modify:before {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  background-color: var(--color-modify);\n}\n.btn-booking-cms-modify:hover {\n  opacity: 0.7;\n}\n.btn-booking-cms-modify:hover:before {\n  opacity: 0.7;\n}", ""]);

// exports
